import React from 'react';
import { number, string } from 'prop-types';
import { useSelector } from 'react-redux';

// Import styles
import {
	Figure,
	Image
} from 'components/elements/molecules/slider/SliderItem/styles';

// Import utilities
import { ImageOnLoadRPC } from 'components/utilities';

const SlideImage = ({ slideHeight, src, alt }) => {
	const { isContrast } = useSelector(
		({ wcag_accessibility }) => wcag_accessibility
	);
	return (
		<Figure slideHeight={slideHeight} isContrast={isContrast} title={alt}>
			<ImageOnLoadRPC>
				{({ setError, isError }) => (
					<Image
						onError={setError}
						src={src}
						isImageUrl={src}
						alt={alt}
						isError={isError}
					/>
				)}
			</ImageOnLoadRPC>
		</Figure>
	);
};

SlideImage.defaultProps = {
	alt: ''
};

SlideImage.propTypes = {
	slideHeight: number.isRequired,
	src: string.isRequired,
	alt: string
};

export default SlideImage;
